import React, { useState, useRef, useEffect } from 'react';
import Button from '../../../../shared/ui/button/Button';
import './ShareDropdown.css';

import whatsapp from '../../../../assets/img/whatsapp.svg';
import messenger from '../../../../assets/img/messenger.svg';
import facebook from '../../../../assets/img/facebook.svg';
import twitter from '../../../../assets/img/twitter.svg';
import pinterest from '../../../../assets/img/pinterest.svg';
import dropbox from '../../../../assets/img/dropbox.svg';
import drive from '../../../../assets/img/drive.svg';
import link from '../../../../assets/img/link.svg';
import plane from '../../../../assets/img/plane.svg';
import download from '../../../../assets/img/download.svg';
import forward from '../../../../assets/img/forward.svg';
import {
    selectCurrentProject,
    selectIsLoadingSharing,
} from '../../../../store/selectors/projectSelectors';
import { useSelector } from 'react-redux';
import { PostModal } from '../../../../shared/ui/post-modal/PostModal';
import { exportProject } from '../../../../shared/api/textProjectApi';
import { useAppDispatch } from '../../../../store/store';
import IconCopyLink from '../../../../shared/ui/icons/IconCopyLink';

const ShareButton: React.FC = () => {
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    const [showPostModal, setShowPostModal] = useState<boolean>(false);
    const isLoadingShare = useSelector(selectIsLoadingSharing);
    const project = useSelector(selectCurrentProject);
    const dispatch = useAppDispatch();

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setShowDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleMakeAPost = () => {
        setShowPostModal(true);
    };

    const handleDownload = () => {
        if (project?.id) {
            dispatch(exportProject(project.id));
        }
    };

    return (
        <>
            <div style={{ position: 'relative', display: 'inline-block' }} ref={dropdownRef}>
                <Button
                    onClick={() => setShowDropdown((prev) => !prev)}
                    text="Share"
                    style={{
                        background: '#FFD83A',
                        fontSize: '12px',
                        borderRadius: '10px',
                        width: '80px',
                    }}
                />
                {showDropdown && (
                    <div className="share-dropdown">
                        {/* <div className="share-container">
                            <div className="icon-grid">
                                <button className="icon-item" disabled>
                                    <IconCopyLink />
                                    <span>Copy</span>
                                </button>
                                <button className="icon-item" disabled>
                                    <img src={whatsapp} alt="WhatsApp" />
                                    <span>WhatsApp</span>
                                </button>
                                <button className="icon-item" disabled>
                                    <img src={messenger} alt="Messenger" />
                                    <span>Messenger</span>
                                </button>
                                <button className="icon-item" disabled>
                                    <img src={facebook} alt="Facebook" />
                                    <span>Facebook</span>
                                </button>
                                <button className="icon-item" disabled>
                                    <img src={twitter} alt="X" />
                                    <span>X</span>
                                </button>
                                <button className="icon-item" disabled>
                                    <img src={pinterest} alt="Pinterest" />
                                    <span>Pinterest</span>
                                </button>
                                <button className="icon-item" disabled>
                                    <img src={dropbox} alt="Dropbox" />
                                    <span>Dropbox</span>
                                </button>
                                <button className="icon-item" disabled>
                                    <img src={drive} alt="Drive" />
                                    <span>Drive</span>
                                </button>
                            </div>
                        </div> */}

                        {/* <div className="share-container">
                            <p className="share-label">Send an email</p>

                            <div className="email-section">
                                <input type="email" placeholder="info@aiohub.gg" disabled />
                                <button disabled>
                                    <img src={forward} alt="Send" />
                                </button>
                            </div>
                        </div> */}

                        {project?.id && (
                            <div className="share-container">
                                {/* <p className="share-label">External</p> */}
                                <div className="external-buttons">
                                    <button
                                        className="external-post"
                                        onClick={handleMakeAPost}
                                        disabled={isLoadingShare}
                                    >
                                        {isLoadingShare ? (
                                            <>
                                                <span className="spinner" /> Posting...
                                            </>
                                        ) : (
                                            <>
                                                <img src={plane} alt="Post" /> Make a post
                                            </>
                                        )}
                                    </button>

                                    <button className="external-download" onClick={handleDownload}>
                                        <img src={download} alt="Download" /> Download
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
            <PostModal isOpen={showPostModal} onClose={() => setShowPostModal(false)} />
        </>
    );
};

export default ShareButton;
